import { DebidaDiligencia } from './debida-diligencia.model';
import { Direccion } from './direccion.model';
import { DocumentoDeIdentidad } from './documento-de-identidad.model';
import { Profesion } from './profesion.model';
import { SectorActividad } from './sector-actividad.model';
import { Pais } from './pais.model';
import { Contacto } from './contacto.model';


export class PersonaFisica
{
    id: number;
    tipo: string;
    active: number;
    nombre: string;
    segundoNombre: string;
    apellido: string;
    segundoApellido: string;
    contacto: Contacto;
    fechaNacimiento: Date;
    lugarNacimiento: Pais;
    paisResidencia: Pais;
    personaPoliticamenteExpuesta: boolean;
    documentoIdentidad: DocumentoDeIdentidad;
    profesion: Profesion;
    //sectorIndustrial: SectorActividad;
    token: string;
    tokenValidoHasta: Date;
    correoElectronico: string;
    direccionFisica: Direccion;
    
    /**
     * Constructor
     *
     * @param personaFisica
     */
    constructor(personaFisica)
    {
        {
            this.id = personaFisica.id || null;
            this.tipo = personaFisica.tipo || null;
            this.active = personaFisica.active || 0;
            this.nombre = personaFisica.nombre || '';
            this.segundoNombre = personaFisica.segundoNombre || '';
            this.apellido = personaFisica.apellido || '';
            this.segundoApellido = personaFisica.segundoApellido || '';
            this.contacto = personaFisica.contacto || new Contacto({});
            this.fechaNacimiento = personaFisica.fechaDeNacimiento;
            this.documentoIdentidad = personaFisica.documentoDeIdentidad || new DocumentoDeIdentidad({});
            this.lugarNacimiento= personaFisica.lugarNacimiento;
            this.paisResidencia= personaFisica.paisResidencia;
            this.personaPoliticamenteExpuesta = personaFisica.personaPoliticamenteExpuesta || false;
            this.profesion = personaFisica.profesion;
            //this.sectorIndustrial = personaFisica.sectorIndustrial;
            this.token = personaFisica.token || '';
            this.tokenValidoHasta = personaFisica.tokenValidoHasta;
            this.correoElectronico = personaFisica.correoElectronico || '';
            this.direccionFisica = personaFisica.direccionFisica || new Direccion({});
        }
    }
}
